import React, { useCallback } from 'react';
import { MdCircle } from 'react-icons/md';
import {
  destroy, get, post, put,
} from './index';
import cleanUpObject from '../cleanUpObject';
import { getPriorityColor } from './site';

export const deleteContact = (id, organizationId) => destroy(`/api/v3/contacts/${id}?organization_id=${organizationId}`);
export const getContact = (organizationId, id) => get(`/api/v3/contacts/${id}?organization_id=${organizationId}`);
export const createContact = (formData, organizationId) => post(`/api/v3/contacts?organization_id=${organizationId}`, formData);
export const updateContact = (formData, organizationId, contactId) => {
  return put(`/api/v3/contacts/${contactId}?organization_id=${organizationId}`, formData);
};
export const getContacts = (organizationId, params) => {
  let queryParamString = {
    organization_id: organizationId,
    name: params.name,
    contact_type: params.contactType,
    company: params.company,
    related_sites: params.relatedSites,
    priority: params.priority,
    h2a: params.h2a,
    direction: params.direction,
    filter: params.sortBy,
    per_page: params.perPage || 20,
    page: params.page || 1,
  };
  cleanUpObject(queryParamString);
  queryParamString = new URLSearchParams(queryParamString).toString();
  return get(`/api/v3/contacts?${queryParamString}`).then((response) => response.json());
};

export const useFetchContacts = ({
  organizationId, params, setContacts, setTotalContacts, setTotalUnfilteredContacts, showToast,
}) => useCallback(() => {
  getContacts(organizationId, params)
    .then((data) => {
      const newData = data.contacts.map(contact => (
        {
          ...contact,
          highest_priority: <div className="flex space-x-2 items-center"><MdCircle size={16} color={getPriorityColor(contact?.highest_priority?.toLowerCase())} /><p>{contact.highest_priority ?? 'No Associated Sites'}</p></div>,
        }
      ));
      setContacts(newData);

      if (setTotalContacts) {
        const isSearchActive = !!params.name || !!params.company || !!params.contactType;
        setTotalContacts(isSearchActive ? data.result_count : data.total_count);
      }

      setTotalUnfilteredContacts?.(data.total_count);
    })
    .catch(error => {
      showToast?.({ message: `Failed to fetch contacts: ${error.message}`, type: 'error' });
    });
}, [organizationId, params, setContacts, setTotalContacts, setTotalUnfilteredContacts, showToast]);
